// Shared state between QR app components

import _ from 'lodash';

class Context {
  constructor(initialState) {
    this._listeners = [];
    this._initialState = initialState;
    this._state = initialState || {};
  }

  get state() {
    return { ...this._state };
  }

  update(state) {
    const newState = { ...this._state, ...state };
    if (_.isEqual(this._state, state)) {
      return;
    }
    this._state = newState;
    this._listeners.forEach(fn => fn(this._state));
  }

  reset() {
    this._state = { ...this._initialState };
    this._listeners.forEach(fn => fn(this._state));
  }

  subscribe(callback) {
    this._listeners.push(callback);
    // unsubscribe
    return () => {
      const i = this._listeners.indexOf(callback);
      (i !== -1) && this._listeners.splice(i, 1);
    };
  }
}

const defaultState = {
  action: '',
  serialNumber: '',
};

export const context = new Context(defaultState);

export const actions = {
  setSerialNumber: serialNumber => {
    actions.clear({ serialNumber });
  },
  setOrders: orders => context.update({ orders }),

  home: () => context.update({ action: '' }),
  scan: () => context.update({ action: 'scan' }),

  clear: props => {
    context.update({
      ..._.pick(defaultState, [
        'action',
        'serialNumber',
      ]),
      ...props,
    });
  },
};

export const ContextMixin = base => class extends base {
  connectedCallback() {
    this.__contextUnsubscribe = context.subscribe(() => this.contextChanged(context.state));
    this.contextChanged(context.state);
    super.connectedCallback?.();
  }

  disconnectedCallback() {
    this.__contextUnsubscribe();
    super.disconnectedCallback?.();
  }

  // This is called every time something is updated
  contextChanged() {
    throw new Error('contextChanged() not implemented', this);
  }
};
